import { TOOL_RENTAL } from '../constants';

const filterProContentCards = (cardArray, isB2BCustomer) => {
  if (!isB2BCustomer) return cardArray

  return cardArray.map((card) => {
    if (card?.info?.title !== TOOL_RENTAL) {
      const { pods, ...newCard } = card;
      const proContentPods = pods.filter((pod) => pod.isProContent);
      return { newCard, pods: proContentPods };
    }
    return card;
  });
};

const getCategoryCards = (data, isB2BCustomer) => {
  const dataForCategoryCards = { ...data };
  const unfilteredCategoryCards = dataForCategoryCards?.searchModel?.orangeGraph?.universalSearchArray;

  if (unfilteredCategoryCards) {
    const { searchModel: { orangeGraph: { universalSearchArray } }, ...restData } = dataForCategoryCards;
    const filteredCards = filterProContentCards(unfilteredCategoryCards, isB2BCustomer)
      .filter((card) => card?.pods.length > 0);
    return { restData, searchModel: { orangeGraph: { universalSearchArray: filteredCards } } };
  }
  return dataForCategoryCards;
}

export { getCategoryCards };
